import React from "react";
import { Breadcrumb } from "../../../components/Breadcrumb";
import { SaveButton } from "../../../components/Buttons";

export const Move = () => {
    document.title = "Yerdəyişmə";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Məhsullar", value: "/products" },
        { name: "Yerdəyişmə", value: "/products/move", current: true },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <article>
                    <h2 className="my-4">Yerdəyişmə</h2>
                    <p>
                        Məhsulların bir anbardan başqa anbara yerdəyişməsi üçün nəzərdə tutulub. Yerdəyişmə sənədi yaratmaq üçün nümunədəki ardıcıllığı icra
                        etmək lazımdır. Açılan pəncərədə əməliyyatları ardıcıllıqla icra edib <SaveButton /> düyməsini sıxmaq lazımdır.
                    </p>
                    <img src="/images/products/documents/move.gif" alt="Yerdəyişmə" />
                </article>
            </div>
        </div>
    );
};
